import { FormContainerStrings, SelectOptionType } from '@argenta/react-ui';
import { t } from '@lingui/macro';

import { SectorsEnum } from '../../enums';

export const formContainerStrings: FormContainerStrings = {
  submitButton: { submit: '' },
};

export const vacancySectorOptions = (): SelectOptionType[] => {
  const sectors = [
    { label: t({ id: 'vacancies.search.sector.MARKETING' }), value: SectorsEnum.MARKETING },
    { label: t({ id: 'vacancies.search.sector.BANKING' }), value: SectorsEnum.BANKING },
    { label: t({ id: 'vacancies.search.sector.DATA' }), value: SectorsEnum.DATA },
    { label: t({ id: 'vacancies.search.sector.FINANCE' }), value: SectorsEnum.FINANCE },
    { label: t({ id: 'vacancies.search.sector.IT' }), value: SectorsEnum.IT },
    { label: t({ id: 'vacancies.search.sector.AGENCIES' }), value: SectorsEnum.AGENCIES },
    {
      label: t({ id: 'vacancies.search.sector.CUSTOMER_SERVICE' }),
      value: SectorsEnum.CUSTOMER_SERVICE,
    },
    { label: t({ id: 'vacancies.search.sector.CREDITS' }), value: SectorsEnum.CREDITS },
    { label: t({ id: 'vacancies.search.sector.LEGAL' }), value: SectorsEnum.LEGAL },
    {
      label: t({ id: 'vacancies.search.sector.PROCESS_MANAGEMENT' }),
      value: SectorsEnum.PROCESS_MANAGEMENT,
    },
    {
      label: t({ id: 'vacancies.search.sector.PROJECT_MANAGEMENT' }),
      value: SectorsEnum.PROJECT_MANAGEMENT,
    },
    {
      label: t({ id: 'vacancies.search.sector.SALES_DISTRIBUTION' }),
      value: SectorsEnum.SALES_DISTRIBUTION,
    },
    { label: t({ id: 'vacancies.search.sector.INSURANCES' }), value: SectorsEnum.INSURANCES },
    { label: t({ id: 'vacancies.search.sector.INTERNSHIP' }), value: SectorsEnum.INTERNSHIP },
    {
      label: t({ id: 'vacancies.search.sector.investing' }),
      value: SectorsEnum.INVESTING,
    },
    {
      label: t({ id: 'vacancies.search.sector.documentManagement' }),
      value: SectorsEnum.DOCUMENT_MANAGEMENT,
    },
    {
      label: t({ id: 'vacancies.search.sector.communication' }),
      value: SectorsEnum.COMMUNICATION,
    },
    {
      label: t({ id: 'vacancies.search.sector.risk' }),
      value: SectorsEnum.RISK,
    },
    {
      label: t({ id: 'vacancies.search.sector.HR' }),
      value: SectorsEnum.HR,
    },
    {
      label: t({ id: 'vacancies.search.sector.leadership' }),
      value: SectorsEnum.LEADERSHIP,
    },
    {
      label: t({ id: 'vacancies.search.sector.commercial' }),
      value: SectorsEnum.COMMERCIAL,
    },
    {
      label: t({ id: 'vacancies.search.sector.starter' }),
      value: SectorsEnum.STARTER,
    },
  ];

  return sectors.sort((a, b) => a.label.localeCompare(b.label));
};
